<div class="content-wrapper" *ngIf="stockService.shareTicker | async">
    <div class="content-body">
        <app-page-header [heading]="title | titlecase"></app-page-header>
        <section>
            <div class="row px-1">
                <div class="col-lg-12 col-12">
                    <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav nav-tabs">
                        <li [ngbNavItem]="1" class="nav-item trends">
                            <a ngbNavLink><i data-feather="trending-up"></i> {{type == 'news' ? 'News' : 'Trend'}}</a>
                            <ng-template ngbNavContent>
                                <div class="w-100">
                                    <h1 class="text-center m-1" *ngIf="!loading && newsData?.length == 0">Data unavailable</h1>
                                    <div class="text-center" *ngIf="loading">
                                        <div class="spinner-border" role="status">
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                    </div>
                                    <div *ngIf="type == 'news'" class="news-container">
                                        <ng-container *ngFor="let news of newsData | paginate: {id: type, itemsPerPage: newsLimit, currentPage: currentPage, totalItems: newsData?.length}">
                                            <ng-container *ngTemplateOutlet="newsSection; context: { news: news }"></ng-container>
                                        </ng-container>
                                        <div class="col-12 text-center" *ngIf="newsData?.length != 0">
                                            <pagination-controls [id]="type" (pageChange)="pageChange($event)" nextLabel="" previousLabel="" directionLinks="true" directionLinks="true"></pagination-controls>
                                        </div>
                                    </div>
                                    <!-- twitter -->
                                    <div *ngIf="type == 'twitter'" class="news-container">
                                        <ng-container *ngFor="let news of newsData | paginate: {id: type, itemsPerPage: newsLimit, currentPage: currentPage, totalItems: newsTotalCount}">
                                            <ng-container *ngTemplateOutlet="twitter; context: { news: news }"></ng-container>
                                        </ng-container>
                                        <div class="col-12 text-center" *ngIf="newsData?.length != 0">
                                            <pagination-controls [id]="type" (pageChange)="pageChange($event)" nextLabel="" previousLabel="" directionLinks="true" directionLinks="true"></pagination-controls>
                                        </div>
                                    </div>
                                    <!-- stocktwitt -->
                                    <div *ngIf="type == 'stocktwitt'" class="news-container">
                                        <ng-container *ngFor="let news of newsData | paginate: {id: type, itemsPerPage: newsLimit, currentPage: currentPage, totalItems: newsTotalCount}">
                                            <ng-container *ngTemplateOutlet="stocktwits; context: { news: news }"></ng-container>
                                        </ng-container>
                                        <div class="col-12 text-center" *ngIf="newsData?.length != 0">
                                            <pagination-controls [id]="type" (pageChange)="pageChange($event)" nextLabel="" previousLabel="" directionLinks="true" directionLinks="true"></pagination-controls>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </li>
                        <li [ngbNavItem]="2"class="nav-item saved">
                            <a ngbNavLink class="nav-link"><i data-feather="save"></i> Saved</a>
                            <ng-template ngbNavContent>
                                <div class="w-100">
                                    <h1 class="text-center m-1" *ngIf="saveNewsData?.length == 0">No Saved News</h1>
                                    <ng-container *ngFor="let news of saveNewsData">
                                        <ng-container *ngIf="type != 'news'">
                                            <ng-container *ngTemplateOutlet="socialSave; context: { news: news }"></ng-container>
                                        </ng-container>
                                        <ng-container *ngIf="type == 'news'">
                                            <ng-container *ngTemplateOutlet="saveNews; context: { news: news }"></ng-container>
                                        </ng-container>
                                    </ng-container>
                                </div>
                            </ng-template>
                        </li>
                    </ul>
                    <div [ngbNavOutlet]="nav"></div>
                </div>
            </div>
        </section>
        <!-- app-toast-container component -->
        <app-toast-container2 aria-live="polite" aria-atomic="true"></app-toast-container2>
    </div>
</div>

<!-- news template -->
<ng-template #newsSection let-news="news">
    <div class="card mb-0 d-flex flex-row align-items-start px-2 py-1">
        <div class="custom-control custom-control-primary custom-checkbox mr-1 mt-1">
            <input type="checkbox" class="custom-control-input" [id]="news?.id" (change)="addSocialSentiment(news?.id)" />
            <label class="custom-control-label" [for]="news?.id"></label>
        </div>
        <div class="d-flex flex-column w-100">
            <div class="d-flex flex-column justify-content-between">
                <!-- TIME -->
                <p class="font-weight-bolder"><span data-feather="watch" class="font-large-1 font-weight-bolder"></span> {{news?.published_utc | date: 'MM/dd/yyyy hh:mm a'}}</p>
                <!-- SOURCE OF NEWS -->
                <p class="font-weight-bolder">SOURCE OF NEWS: {{news?.publisher?.name}}</p>
            </div>
            <div class="text-wrap">
                <span><a [href]="news?.article_url" target="_blank" rel="noopener noreferrer">{{news?.title}}</a></span>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #saveNews let-news="news">
    <div class="card mb-0 d-flex flex-row align-items-start px-2 py-1">
        <button type="button" class="btn btn-icon btn-outline-danger mr-1 mt-1" (click)="deleteNews(news?.id)">
            <i data-feather="trash-2"></i>
        </button>
        <div class="d-flex flex-column w-100">
            <div class="d-flex flex-column justify-content-between">
                <!-- TIME -->
                <p class="font-weight-bolder"><span data-feather="watch" class="font-large-1 font-weight-bolder"></span> {{news?.recordedOn | date: 'MM/dd/yyyy hh:mm a'}}</p>
            </div>
            <div class="text-wrap">
                <span><a [href]="news?.url" target="_blank" rel="noopener noreferrer">{{news?.title}}</a></span>
            </div>
        </div>
    </div>
</ng-template>

<!-- twitter news template -->
<ng-template #twitter let-news="news">
    <div class="card mb-0 d-flex flex-row align-items-start px-2 py-1">
        <div class="custom-control custom-control-primary custom-checkbox mr-1 mt-1">
            <input type="checkbox" class="custom-control-input" [id]="news?.id" (change)="addSocialSentiment(news?.id)" />
            <label class="custom-control-label" [for]="news?.id"></label>
        </div>
        <div class="d-flex flex-column w-100">
            <div class="d-flex flex-row justify-content-between">
                <!-- SOURCE OF NEWS -->
                <p class="font-weight-bolder"><span data-feather="twitter" class="twitter-icon font-large-1 font-weight-bolder"></span> {{news?.tweet_by}}</p>
                <!-- TIME -->
                <p class="text-right font-weight-bolder"><span data-feather="watch" class="font-large-1 font-weight-bolder"></span> {{news?.postDate}}</p>
            </div>
            <div class="text-wrap">
                <span>{{news?.tweet}}</span>
            </div>
        </div>
    </div>
</ng-template>

<!-- stocktwits news template -->
<ng-template #stocktwits let-news="news">
    <div class="card mb-0 d-flex flex-row align-items-start px-2 py-1">
        <div class="custom-control custom-control-primary custom-checkbox mr-1 mt-1">
            <input type="checkbox" class="custom-control-input" [id]="news?.id" (change)="addSocialSentiment(news?.id)" />
            <label class="custom-control-label" [for]="news?.id"></label>
        </div>
        <div class="d-flex flex-column w-100">
            <div class="d-flex flex-row justify-content-between">
                <!-- SOURCE OF NEWS -->
                <p class="font-weight-bolder">{{news?.tweet_by}}</p>
                <!-- TIME -->
                <p class="text-right font-weight-bolder"><span data-feather="watch" class="font-large-1 font-weight-bolder"></span> {{news?.postDate}}</p>
            </div>
            <!-- <div class="d-flex flex-row justify-content-between"> -->

                <!-- SOURCE OF NEWS -->
                <!-- <p class="font-weight-bolder">LIKES: {{news?.likes}}</p> -->
            <!-- </div> -->
            <div class="text-wrap">
                <span>{{news?.tweet}}</span>
            </div>
        </div>
    </div>
</ng-template>

<!-- twitter news template -->
<ng-template #socialSave let-news="news">
    <div class="card mb-0 d-flex flex-row align-items-start px-2 py-1">
        <button type="button" class="btn btn-icon btn-outline-danger mr-1" (click)="deleteSocialSentiment(news?.Id)">
            <i data-feather="trash-2"></i>
        </button>
        <div class="d-flex flex-column w-100">
            <div class="d-flex flex-row justify-content-between">
                <!-- SOURCE OF NEWS -->
                <p class="font-weight-bolder">Tweet By: {{news?.TwittedBy}}</p>
                <!-- TIME -->
                <p class="text-right font-weight-bolder"><span data-feather="watch" class="font-large-1 font-weight-bolder"></span> {{news?.postDate}}</p>
            </div>
            <!-- <div class="d-flex flex-row justify-content-between"> -->

                <!-- SOURCE OF NEWS -->
                <!-- <p class="font-weight-bolder">LIKES: {{news?.likes}}</p> -->
            <!-- </div> -->
            <div class="text-wrap">
                <span>{{news?.tweet}}</span>
            </div>
        </div>
    </div>
</ng-template>